import { render } from "./labelReports.vue?vue&type=template&id=3af3c9b4"
import script from "./labelReports.vue?vue&type=script&lang=js"
export * from "./labelReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__